import {DialogType } from '@tableau/widgets';
import * as React from 'react';

import { dialogBodyStyle } from '~src/app/content/styles/ExternalContentActionsStyles';
import { Messages } from '~src/codegen/Localize';
import { ModalInstance, ReactModalOptions, ReactModalService } from '~src/commonInfra/dialogs/ReactModalService';

import { FlowSubscriptionCreationDialogContent } from './FlowSubscriptionCreationDialogContent';

export function showCreateFlowSubscriptionDialog(flowId: string, flowName: string): Promise<any> {
  let modalInstance: ModalInstance;
  const dismiss = () => modalInstance.dismiss();
  const props = {
    flowId: flowId,
    dismiss: dismiss,
    flowName: flowName,
  };
  const dialog: ReactModalOptions = {
    type: DialogType.NormalWithTitleBar,
    title: Messages.flowSubscriptionsAddFlowSubscription(),
    dialogContent: FlowSubscriptionCreationDialog(props),
    showCloseButton: true,
    dialogWidth: 600,
    shouldRecenterOnUpdate: true,
    dialogBodyStyle: dialogBodyStyle,
  };
  modalInstance = ReactModalService.open(dialog);
  return modalInstance.result.catch(() => {});
}

export type FlowSubscriptionCreationDialogProps = {
  flowId: string;
  dismiss: () => void;
  flowName: string;
}

export function FlowSubscriptionCreationDialog(props: FlowSubscriptionCreationDialogProps): JSX.Element {
  return (
    <FlowSubscriptionCreationDialogContent
      flowId={props.flowId}
      dismiss={props.dismiss}
      flowName={props.flowName}
    />
  );
}